module.exports = __webpack_public_path__ + "static/media/map-pin.17eb1467.svg";